export class OpenRecordLink {};